import { z } from 'zod';
import { CreditResolutionMethod, CrewClaimTypeEnum } from '../../enums/crew.js';
import { enumToZodLiteralUnion } from '../../zodExtensions.js';
import { claimAddress } from './address.js';
import { calculatedOrderLineItem, calculatedOrderLineItemResponse, } from './claimLineItem.js';
import { customerUiEventCustomField } from './customField.js';
import { Pegasus } from './pegasus.js';
import { rate, returnShipmentMethod } from './shipmentRate.js';
export const calculatedOrder = z.object({
    id: z.number(),
    claimType: enumToZodLiteralUnion(CrewClaimTypeEnum),
    calculatedLineItems: z.array(calculatedOrderLineItem),
    returnShipment: returnShipmentMethod.nullish(),
    toCustomerRate: rate.nullish(),
    exchangeMethod: z
        .union([z.literal('instant'), z.literal('standard')])
        .optional(),
    creditResolutionMethod: z.nativeEnum(CreditResolutionMethod).optional(),
});
export const calculatedOrderShipmentQuote = calculatedOrder
    .omit({
    returnShipment: true,
    toCustomerRate: true,
})
    .extend({
    address: claimAddress,
});
export const calculatedOrderNoResolutions = calculatedOrder
    .omit({
    returnShipment: true,
    toCustomerRate: true,
    calculatedLineItems: true,
})
    .extend({
    calculatedLineItems: z.array(calculatedOrderLineItem.omit({
        requestedResolutionMethodEnum: true,
    })),
});
// --------- response bodies -----------------------
export const calculatedAfterReasonSelection = z.object({
    eventPolicyEnforcement: Pegasus.eventPolicyEnforcement.nullable(),
    eventCustomFields: customerUiEventCustomField.nullable(),
});
const ReturnSummarySectionType = {
    SHIPPING: 'SHIPPING',
    RETURN_SHIPPING: 'RETURN_SHIPPING',
    INCENTIVE: 'INCENTIVE',
    FEE: 'FEE',
    TAX: 'TAX',
    SUBTOTAL: 'SUBTOTAL',
};
const financialSection = z.object({
    total: z.number(),
    lineItems: z.array(calculatedOrderLineItemResponse),
    sections: z.array(z.object({
        type: z.nativeEnum(ReturnSummarySectionType),
        label: z.string(),
        amount: z.number(),
    })),
});
export const calculatedBeforeClaimSubmission = z.object({
    credits: financialSection,
    deductions: financialSection,
    balance: z.number(),
    paymentIntent: z
        .object({
        clientSecret: z.string(),
        amount: z.number(),
        idFromPlatform: z.string(),
    })
        .optional(),
});
//# sourceMappingURL=calculatedOrder.js.map